module.exports = __webpack_public_path__ + "media/1x1/wf-05522b9f.svg";